import React from 'react';
import { CenteredMessage } from './CenteredMessage';

function SummaryTabComponent({ summary }) {
  return (
    <div style={{ height: 'auto' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '20px'
      }}>
        <div style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1f2937',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          Summary
        </div>
      </div>

      <div style={{
        height: '100%',
        overflowY: 'auto',
        padding: '20px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        {summary ? (
          <div style={{
            marginBottom: '16px',
            padding: '12px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}>
            <p style={{ margin: 0, color: '#374151' }}>{summary}</p>
          </div>
        ) : (
          <CenteredMessage text="No transcript available" />
        )}
      </div>
    </div>
  );
}

export default SummaryTabComponent;
